import clsx from 'clsx';
import { observer } from 'mobx-react';
import { resetModal } from '..';
import { T } from '../../../../../../../Translations';
import Button from '../../../../../../Form/Button';
import ModalStore from '../../../../../../Modal/Store';
import ReclaimLicensesStore from '../../Store';
import { Succeeded } from '../../Types';

interface Props {
  modalStore: ModalStore;
  state: Succeeded;
  store: ReclaimLicensesStore;
}

function SucceededBody({ modalStore, state, store }: Props) {
  return (
    <div className="flex justify-center flex-col">
      <div className="font-semibold text-2xl text-center">
        <T kind="Access Removed" />
      </div>
      <div className="mt-4 text-center">
        <div>
          <p>
            <T
              kind="You removed access for <span>{{count}} participant</span> who is no longer with your organization."
              count={state.userCount}
              span={(content) => <span className="font-bold">{content}</span>}
            />
          </p>
          <p>
            <T
              kind="As a result, <span>{{count}} Activated license</span> was reclaimed for future use."
              count={state.reclaimedLicenseCount}
              span={(content) => <span className="font-bold">{content}</span>}
            />
          </p>
        </div>
      </div>
      <Button
        className={clsx(
          'rounded-md cursor-pointer font-semibold bg-teal-600 border px-3 py-3 text-sm w-1/2',
          'text-center mt-6 mb-4 mx-auto text-white',
        )}
        value="Done"
        type="button"
        onClick={() => {
          resetModal(modalStore, store);
          store.participantsStore.loading(1);
        }}
      />
    </div>
  );
}

export default observer(SucceededBody);
